import { SET_FEATURES, FeatureFlags, FeaturesTypes } from './types';

const initialState: FeatureFlags = {};

export function featuresReducer(
    state = initialState,
    action: FeaturesTypes): FeatureFlags {
        switch(action.type){
            case SET_FEATURES:
                return action.payload;
            default:
                return state;
        }
}
